import FaqTipsList from './FaqTipsList'

export default FaqTipsList
